/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React from "react";
import * as SC from "./PrintCardHeader.styled";
import { WinnerDot, WinnerWrapper } from "../../PrintMetricsValue/PrintMetricsValue.styled";

import { useTranslation } from "react-i18next";

const PrintCard = ({ title, showWinner = true }) => {
  const { t } = useTranslation();

  return (
    <SC.Wrapper>
      <SC.Title>{t(title)}</SC.Title>
      {showWinner && (
        <WinnerWrapper>
          <WinnerDot />
          {t("Winner")}
        </WinnerWrapper>
      )}
    </SC.Wrapper>
  );
};
export default PrintCard;
